import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCompressExcel = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 54 64"
    {...props}
  >
    <rect
      width={53}
      height={63}
      x={0.5}
      y={0.5}
      fill="#fff"
      stroke="#E5E6EB"
      rx={4.5}
    />
    <rect width={38} height={16} x={8} y={44} fill="#1BCF63" rx={3} />
    <path
      fill="#fff"
      d="M14.497 56.5q-.077 0-.11-.033-.023-.045.022-.121l2.189-3.663a.055.055 0 0 0 0-.066l-2.19-3.663a1 1 0 0 1-.021-.077q0-.077.11-.077h1.1q.12 0 .165.088l1.606 2.728q.033.066.066 0l1.617-2.728q.043-.088.154-.088h1.1q.076 0 .099.044.033.033-.011.11l-2.19 3.663a.1.1 0 0 0 0 .066l2.19 3.663q.021.066.022.077 0 .077-.11.077h-1.1q-.11 0-.154-.088l-1.617-2.717q-.033-.066-.066 0l-1.617 2.717q-.045.088-.154.088zm7.229 0a.16.16 0 0 1-.099-.033.16.16 0 0 1-.033-.099v-7.436q0-.055.033-.088a.14.14 0 0 1 .099-.044h1.012q.055 0 .088.044.044.033.044.088v6.413q0 .055.055.055h3.685q.055 0 .088.044.044.033.044.088v.836q0 .056-.044.099a.12.12 0 0 1-.088.033zm8.638.088q-.858 0-1.496-.275t-.99-.77q-.34-.495-.34-1.166v-.275q0-.055.032-.088a.14.14 0 0 1 .1-.044h.978q.055 0 .088.044.045.033.044.088v.209q0 .506.451.847.45.33 1.232.33.671 0 1.012-.286a.92.92 0 0 0 .341-.737.75.75 0 0 0-.187-.517 1.7 1.7 0 0 0-.539-.396 11 11 0 0 0-1.034-.44q-.78-.285-1.265-.539a2.4 2.4 0 0 1-.814-.682q-.318-.44-.319-1.089 0-.968.704-1.529.705-.561 1.881-.561.825 0 1.452.286.638.285.99.803.352.506.352 1.177v.187q0 .056-.044.099a.12.12 0 0 1-.088.033h-.99a.16.16 0 0 1-.099-.033.16.16 0 0 1-.033-.099v-.121q0-.517-.429-.869-.417-.363-1.166-.363-.604 0-.946.253-.33.253-.33.715 0 .33.176.539.175.21.528.385.352.165 1.09.429.78.297 1.242.539.474.242.803.682.34.429.341 1.078 0 .99-.737 1.573-.726.583-1.99.583m3.329-.088q-.077 0-.11-.033-.022-.045.022-.121l2.189-3.663a.055.055 0 0 0 0-.066l-2.189-3.663a1 1 0 0 1-.022-.077q0-.077.11-.077h1.1q.12 0 .165.088l1.606 2.728q.033.066.066 0l1.617-2.728q.044-.088.154-.088h1.1q.077 0 .099.044.033.033-.011.11L37.4 52.617a.1.1 0 0 0 0 .066l2.189 3.663q.022.066.022.077 0 .077-.11.077h-1.1q-.11 0-.154-.088l-1.617-2.717q-.033-.066-.066 0l-1.617 2.717q-.044.088-.154.088z"
    />
    <rect
      width={6}
      height={26}
      fill="#DCDDE5"
      rx={2}
      transform="matrix(-1 0 0 1 15 9)"
    />
    <rect
      width={28}
      height={18}
      fill="#DCDDE5"
      rx={2}
      transform="matrix(-1 0 0 1 45 17)"
    />
    <rect
      width={28}
      height={6}
      fill="#A9AABC"
      rx={2}
      transform="matrix(-1 0 0 1 45 9)"
    />
  </svg>
);
export default SvgCompressExcel;
